// extracted by mini-css-extract-plugin
module.exports = {"container":"ChatWindow_container__yemxE"};